import { REGEX } from "../constants/regex";
import { STRING } from "../constants/string";
import { TypeChecker } from "./TypeChecker";

export class FormatNumber {
  constructor(
    private value: string | number,
    private precision?: number,
  ) {
    if (!this.value || this.value === STRING.MINUS) {
      return;
    }

    const [first, last] = value.toString()
      .replace(REGEX.FULL_NUMBER, STRING.EMPTY)
      .split(REGEX.DOT_OR_COMMA);

    this._int = Number(first).toLocaleString("uk-UK") || STRING.ZERO;
    this._last = last || STRING.EMPTY;
  }

  private _int: string = STRING.EMPTY;
  private _last: string = STRING.EMPTY;

  get currency() {
    // price завжди округлюємо до 2х знаків після коми
    const fraction = this._last.toString().padEnd(2, STRING.ZERO).substring(0, this.precision);
    return fraction ? `${this._int}${STRING.DOT}${fraction}` : this._int;
  }

  get number() {
    const hasPrecision = !new TypeChecker().isUndefined(this.precision);
    const hasDivider = REGEX.DOT_OR_COMMA.test(this.value as string);
    const keepDivider = hasPrecision ? hasDivider && this.precision !== 0 : hasDivider;
    const fraction = hasPrecision ? this._last.substring(0, this.precision) : this._last;
    return keepDivider ? `${this._int}${STRING.DOT}${fraction}` : this._int;
  }
}
